/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');
require('jquery-mask-plugin');

import Vue from 'vue';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});



//WALLET-ID BLADE JS
$("#accountNumber").mask("9999999-9");

function changeDocTypeClass() {
    const select = document.getElementById('docType');
    const inputDoc = document.getElementById('cpfcnpj');
    if(select) {

        if (inputDoc) {
            inputDoc.setAttribute('disabled', 'disabled');
            select.options.selectedIndex = 0;
        }


        select.addEventListener('change', (el) => {
            const options = select.options
            const index = options.selectedIndex;

            const optionSelected = options[index];

            

            if (index != 0) {
                inputDoc.removeAttribute('disabled');

                if (optionSelected.value == 'cpf') {

                    inputDoc.value = '';
                    inputDoc.placeholder = '';
                    inputDoc.classList.add('cpf');
                    inputDoc.classList.remove('cnpj');

                    $('.cpf').mask('000.000.000-00', {
                        reverse: true,
                        placeholder: 'Ex.: 123.456.789-00'
                    });

                } else if (optionSelected.value == 'cnpj') {
                    inputDoc.value = '';
                    inputDoc.placeholder = '';
                    inputDoc.classList.remove('cpf');
                    inputDoc.classList.add('cnpj');

                    $('.cnpj').mask('999.999.999/9999-99', {
                        reverse: true,
                        placeholder: 'Ex.: 123.456.789/0001-99'
                    });

                }

            } else {
                inputDoc.setAttribute('disabled', 'disabled');                
                inputDoc.classList.remove('cpf');
                inputDoc.classList.remove('cnpj');
                inputDoc.value = '';
                inputDoc.placeholder = '';
            }
        })
    }

}
changeDocTypeClass();

function swalWalletId() {
    Swal.fire({
        title: 'WalletId',
        html: '<br>Para que o RodioPay possa fazer a divisão de pagamento entre contas, é necessário que seja informada a Wallet ID do Assas.'+
        '<br><br>'
        + '<a href="wallet-id-tutorial" target="_blank">Clique Aqui</a> e veja '
        + 'como obter este código para preencher o campo adequado no formulário abaixo.',
        confirmButtonText:
        '<i class="fa fa-thumbs-up"></i> Ok!',
        confirmButtonColor: "#494FBF",
    })
}

function modalWhatIsWallet(){

    const interrogationWalletId = document.getElementById('whatIsWalletId');
    
    if(interrogationWalletId){

        interrogationWalletId.addEventListener("click", swalWalletId, false)
    }    
}

modalWhatIsWallet();



function handlingWalletFormSubmit(){

    const walletIdButtonFormSubmit = document.getElementById('walletIdButtonFormSubmit');

    const inputNameField = document.getElementById('name');
    const inputCpfCnpjField = document.getElementById('cpfcnpj');
    const inputWalletIdField = document.getElementById('walletId');
    const inputAccountNumberField = document.getElementById('accountNumber');

    const formWalletId = document.getElementById('walletIdSaveForm');

    function verifyNameInput(){

        if(inputNameField && inputNameField.value.length < 5){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'O nome é inválido!',
            })
            return false
            
        } else {   
            return true
        }
    }

    function verifyCpfCnpjInput(){

        if(inputCpfCnpjField && inputCpfCnpjField.value.length < 13){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Cpf ou Cnpj inválido!',
            })
            console.log('false',inputCpfCnpjField.value.length)
            return false
        
        } else {   
            console.log('true',inputCpfCnpjField.value.length)
            return true
        }
    }

    function verifyWalletIdInput(){

        if(inputWalletIdField && inputWalletIdField.value.length < 32){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'WalletId inválido!',
            })
            return false
            
        } else {   
            return true
        }
    }

    function verifyAccountNumberInput(){

        if(inputAccountNumberField && inputAccountNumberField.value.length < 9){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Número da conta inválido!',
            })
            return false    
        } else {   
            return true
        }
    }

    
    if(walletIdButtonFormSubmit){

        walletIdButtonFormSubmit.addEventListener("click", () => {
            if(verifyNameInput() && verifyCpfCnpjInput() && verifyWalletIdInput() && verifyAccountNumberInput()){
                formWalletId.submit()
            }
        }, false)
    }    
}


handlingWalletFormSubmit();
